import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  ElementRef,
  ViewChild
} from "@angular/core";

@Component({
  selector: "lib-progress-bar",
  templateUrl: "./progress-bar.component.html",
  styleUrls: ["./progress-bar.component.scss"]
})
export class ProgressBarComponent implements OnInit, OnChanges {
  @Input() progress: number;
  @Input() animation: boolean = true;
  @Input() color: string = null;
  @Input() labelPosition: 'start' | 'end' = 'end'
  @ViewChild("progressBarValue") progressBarValue: ElementRef;
  @ViewChild("progressBarLabel") progressBarLabel: ElementRef;

  colors = {
    loading: "rgb(210, 142, 24)",
    completed: "#439c4a"
  };

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes.progress != null || changes.progress != undefined) &&
      (changes.progress.currentValue != null || changes.progress.currentValue != undefined)
    ) {
      setTimeout(() => {
        this.setProgress(this.progress);
      });
    }
  }

  ngOnInit() { }

  private setProgress = (progress: number) => {
    if (!this.progressBarValue || !this.progressBarLabel || progress > 100) {
      return false;
    }
    const progressbarElement = this.progressBarValue.nativeElement;
    const labelElement = this.progressBarLabel.nativeElement;
    labelElement.textContent = `${progress}%`;
    progressbarElement.style.width = `${progress}%`;

    if (progress < 100) {
      progressbarElement.style.backgroundColor = this.color ? this.color : this.colors.loading;
      if (
        this.animation &&
        !progressbarElement.className.includes("progress-bar-animation")
      ) {
        progressbarElement.classList.add("progress-bar-animation");
      }
    } else {
      progressbarElement.style.backgroundColor = this.color ? this.color : this.colors.completed;
      progressbarElement.classList.remove("progress-bar-animation");
    }
  };
}
